import * as React from "react";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as productionJobLineItemBreakdownTableFragments } from "../ProductionJobLineItemBreakdownTable/graph";
import ProductionJobLineItemBreakdownTable from "../ProductionJobLineItemBreakdownTable";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  descriptionList: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  },

  descriptionListItem: {
    display: "flex"
  },

  descriptionTag: {
    marginRight: theme.spacing(1)
  }
}));

const StyleSubstitutionLineItemBreakdown = ({ lineItems }) => {
  const classes = useStyles();

  return (
    <div>
      {lineItems.map(lineItem => (
        <div key={lineItem.id}>
          <dl className={classes.descriptionList} key={lineItem.id}>
            <div className={classes.descriptionListItem}>
              <Typography
                className={classes.descriptionTag}
                component="dt"
                variant="subtitle2"
                color="textSecondary"
              >
                Vendor:
              </Typography>
              <Typography align="left" component="dd" variant="body2">
                {lineItem.styleSubstitution.vendor}
              </Typography>
            </div>
            <div className={classes.descriptionListItem}>
              <Typography
                className={classes.descriptionTag}
                component="dt"
                variant="subtitle2"
                color="textSecondary"
              >
                Style:
              </Typography>
              <Typography align="left" component="dd" variant="body2">
                {lineItem.styleSubstitution.style}
              </Typography>
            </div>
            <div className={classes.descriptionListItem}>
              <Typography
                className={classes.descriptionTag}
                component="dt"
                variant="subtitle2"
                color="textSecondary"
              >
                Description:
              </Typography>
              <Typography align="left" component="dd" variant="body2">
                {lineItem.styleSubstitution.description}
              </Typography>
            </div>
          </dl>
          <ProductionJobLineItemBreakdownTable
            lineItems={filter(
              productionJobLineItemBreakdownTableFragments.lineItems,
              [lineItem]
            )}
          />
        </div>
      ))}
    </div>
  );
};

export default StyleSubstitutionLineItemBreakdown;
